import {
  advancedFormGroup
} from '@magieno/common';
import { IsOptional, ValidateIf, ValidateNested } from '@pristine-ts/class-validator';
import { translationBaseKey } from '../../../../../decorators/translation-base-key.decorator';
import { type } from '@pristine-ts/data-mapping-common';
import { IncomeTaxPersonalChildCommonOptions } from '../common/income-tax-personal-child-common.options';
import {
  IncomeTaxPersonalChildFederalInIncomeTaxPersonalOptions,
} from './income-tax-personal-child-federal-in-income-tax-personal.options';
import {
  IncomeTaxPersonalChildQuebecInIncomeTaxPersonalOptions,
} from './income-tax-personal-child-quebec-in-income-tax-personal.options';

@translationBaseKey('income-tax-child-options')
export class IncomeTaxPersonalChildOptions extends IncomeTaxPersonalChildCommonOptions {
  @type(() => new IncomeTaxPersonalChildFederalInIncomeTaxPersonalOptions())
  @advancedFormGroup({
    classType: IncomeTaxPersonalChildFederalInIncomeTaxPersonalOptions,
  })
  @ValidateNested()
  @IsOptional()

  // todo: we know currentPath's last part will be this class. Remove our part and get our parent from the path.
  @ValidateIf((object: any, root: any, currentPath: string): boolean => {

    /*
    The code below is a replacement for this since we don't know for sure if the instanceof will work.
    if(root instanceof IncomeTaxPersonalOptions) {
      return root.isCareExpensesCalculated;
    } else if(root instanceof SalaryDividendOptions) {
      return root.incomeTaxPersonalOptions.isCareExpensesCalculated;
    }
     */

    if (root.hasOwnProperty('isCareExpensesCalculated')) {
      return root['isCareExpensesCalculated'];
    } else if (root.hasOwnProperty('incomeTaxPersonalOptions') && root['incomeTaxPersonalOptions'].hasOwnProperty('isCareExpensesCalculated')) {
      return root['incomeTaxPersonalOptions']['isCareExpensesCalculated'];
    }

    return false;
  })
  federal?: IncomeTaxPersonalChildFederalInIncomeTaxPersonalOptions;

  @type(() => new IncomeTaxPersonalChildQuebecInIncomeTaxPersonalOptions())
  @advancedFormGroup({
    classType: IncomeTaxPersonalChildQuebecInIncomeTaxPersonalOptions,
  })
  @ValidateNested()
  @IsOptional()
  quebec?: IncomeTaxPersonalChildQuebecInIncomeTaxPersonalOptions;
}
